/**
 * An interface for a hyperlink
 * @docs
 * @global
 */
export interface HyperlinkObj {
  /* the hyperlink url (fragment) value */
  href: string;

  /* the language of the linked resource */
  hreflang?: string;

  /* the relationship between the current document and the linked document */
  rel?: string;

  /* the context in which the linked resource will open */
  target?: string;

  /* the onClick handler of the link */
  onClick?: (evt: MouseEvent) => void;
}

/**
 * Describes a link.
 * @docs
 * @global
 */
export type Hyperlink = HyperlinkObj | string;

/**
 * Given a link object or string (href), this function will return the full object that describes a link
 * That way we can "combine" the two possible link inputs (string or obj) and work with objects as a result
 * @param   {Hyperlink}     link  The link data
 * @returns {HyperlinkObj}        The link in obj form
 */
export const getHyperLinkObject = (link: Hyperlink): HyperlinkObj => {
  if (typeof link === 'string') {
    return { href: link };
  }
  return link;
};
